export { default } from './CommentDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/CommentDisplay/index.js